import React from "react";

export function getError() {
  return {
    message: (
      <span>
        Something went wrong! Try again or contact{" "}
        {
          <a
            href="https://help.videosquirrel.app/"
            target="_blank"
            rel="noopener noreferrer"
          >
            support
          </a>
        }{" "}
        if the problem persists.
      </span>
    )
  };
}

export function changeThumbnail({ setThumbnailFile, setThumbnail }) {
  return (file) => {
    const jsFile = new File(file, "profile_image");
    setThumbnailFile(jsFile);
    const dataReader = new FileReader();
    dataReader.onload = (event) => {
      setThumbnail(event.target.result);
    };
    dataReader.readAsDataURL(jsFile);
  };
}
